import { Inline } from '@99designs/emu';
import { Scroll, Tenant, get99dUrl } from '@99designs/marketing-ui';
import { linkTo } from '@99designs/routing';
import { DesignCard } from '../components/DesignCard';
import { trackLink } from '../lib/tracking';
import type { Design } from '../types';

export interface DesignInspirationProps {
    designs: Design[];
    tenant?: Tenant;
    crossPlatformTrackingParams?: string;
    productNameForTracking?: string;
    productIdForTracking?: string;
}

export function DesignInspiration({
    designs,
    tenant = Tenant.NinetyNineDesigns,
    crossPlatformTrackingParams,
    productNameForTracking,
    productIdForTracking,
}: DesignInspirationProps) {
    return (
        <Scroll controlsEnabled={true}>
            <Inline space="1.5bu">
                {designs.map((design, index) => (
                    <DesignCard
                        key={index}
                        src={design.image}
                        displayName={design.designer.displayName}
                        profileUrl={get99dUrl(
                            tenant,
                            `${linkTo.userProfile(design.designer.id)}${
                                crossPlatformTrackingParams ? `?${crossPlatformTrackingParams}` : ''
                            }`
                        )}
                        avatarUrl={get99dUrl(
                            tenant,
                            `${linkTo.userAvatar(design.designer.id)}${
                                crossPlatformTrackingParams ? `?${crossPlatformTrackingParams}` : ''
                            }`
                        )}
                        onClick={(event) => {
                            if (tenant === Tenant.Vistaprint) {
                                trackLink(
                                    event,
                                    'Clicked CTA on Product page',
                                    'Navigation Clicked',
                                    {
                                        category: 'Product Page',
                                        label: 'Content:Inspirations',
                                        eventDetail: `/design/${productNameForTracking};${get99dUrl(
                                            tenant,
                                            `${linkTo.userProfile(design.designer.id)}`
                                        )};Inspirations;${design.designer.displayName}`,
                                        navigationDetail: design.designer.displayName,
                                        pageName: `${productIdForTracking}:Product Page`,
                                        pageStage: 'Discover',
                                        pageSection: 'Product Page',
                                        pageDept: 'Design Services',
                                    }
                                );
                            }
                        }}
                    />
                ))}
            </Inline>
        </Scroll>
    );
}
